import {StorageType} from "@app/customer-management/organisation-units/domain/storage-type";

export class Storage {
    id: number;
    type: StorageType;
    settings: any;

    constructor(type: StorageType, id: number) {
        this.type = type;
        this.settings = {}
        this.id = id;
    }

    public static digStorage(id: number) : Storage {
        return new Storage(StorageType.DIG, id);
    }

    public static googleStorage(id: number, settings: any) : Storage {
        const googleStorage = new Storage(StorageType.Google, id);
        googleStorage.settings = settings;
        return googleStorage;
    }

    public static sharepointStorage(id: number, settings: any) : Storage {
        const googleStorage = new Storage(StorageType.Sharepoint, id);
        googleStorage.settings = settings;
        return googleStorage;
    }
}
